import React, {memo, useCallback} from "react"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {useBackground} from "../../../../hooks/background-class"
import iconTheme1 from "../../../../assets/images/icons/theme1.png"
import iconTheme2 from "../../../../assets/images/icons/theme2.png"
import {useChangeTheme} from "../../../../hooks/change-theme"
import {ThemeModel} from "../../../../store/ui/state"
import "./index.scss"

export const CustomIconTheme = memo(function CustomIconTheme() {
    const [,,backgroundStyle] = useBackground()
    const {theme, setTheme} = useChangeTheme()
    const setThemeCallback = useCallback(
        (theme: ThemeModel) => {
            setTheme(theme)
            // window.location.reload()
        },
        [setTheme]
    )

    return (
        <PasswordContainer requiredRole="default" isFullscreen={true}>
            <SettingsPageContainer
                buttons={[]}
                backUrl={"/settings/custom-menu"}
                className={"background-settings"}
                style={backgroundStyle}
            >
                <div className="icon-theme-container">
                    <div
                        className={`icon-theme-box ${theme === "default" ? "icon-theme-active" : ""}`}
                        onClick={() => setThemeCallback("default")}
                    >
                        <img src={iconTheme1} alt="" />
                    </div>
                    <div
                        className={`icon-theme-box ${theme === "rounded" ? "icon-theme-active" : ""}`}
                        onClick={() => setThemeCallback("rounded")}
                    >
                        <img src={iconTheme2} alt="" />
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
